import '../css/Card.css';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const Card = ({ title, dimCardId, data, total, year, compare, tooltip, divideBy1000 = true, isQuantity = false }) => {
  // Stessa convenzione: "value: …" per qty o per euro (€/1000 o € interi)
  const valueLabel = isQuantity
    ? (divideBy1000 ? 'value: Qty/1000' : 'value: Qty')
    : (divideBy1000 ? 'value: €/1000' : 'value: €');
  // Intestazioni colonne: anno e confronto (il tipo è già nel value sopra)
  const col1 = year;
  const col2 = compare;

  return (
  <div className="CardBody">
    <div className='titleContent' >
      <h3 className="CardTitle">{title} 
        <span className="tooltip-wrapper">
          <FontAwesomeIcon 
            icon={faInfoCircle} 
            className="title-icon"
            style={{ height: '13px', marginLeft: '8px', color: '#20362C', background:'white', border: '1px solid white', borderRadius: '50%'}} 
          />
          {tooltip && (
            <span className="tooltip-bubble">
              <span className="tooltip-content">{tooltip}</span>
              <span className="tooltip-arrow"></span>
            </span>
          )}
        </span>
      </h3>
      <span className="titleSpan">{valueLabel}</span>
    </div>

    <div className="columnHeader">
      <span className="flex-1"></span>
      <span className="">{col1}</span>
      <span className="">{col2}</span>
      <span className="">Delta</span>
    </div>

    <div className="">
      {data.map((item, index) => (
        <div key={index} className="TEST">
          <span className="label cell">
            {item.refUrl ? (
              <a 
                className='label clickable-row' 
                href={item.refUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                title={`Clicca per aprire: ${item.refUrl}`}
              >
                {item.label}
              </a>
            ) : (
              <span className='label normal-row'>{item.label}</span>
            )}
          </span>
          <span className="value cellval">{item.value}</span>
          <span className="value cellval">{item.value2}</span>
          <span className="value cellval delta">
            {typeof item.value3 === 'object' && item.value3 !== null ? (
              <span className="value3-stack">
                <span className="value3-diff">{item.value3.diff}</span>
                <span className="value3-pct">{item.value3.pct}</span>
              </span>
            ) : item.value3}
          </span>
        </div>       
      ))}
    </div>
    <hr/>
    {total.map((item, index) => ( 
          <div key={index} className="TEST">
      <span className="label tot cell">{item.label}</span>
      <span className="totvalue value cellval">{item.value}
      </span>
        <span className="totvalue2 value cellval">{item.value2}</span>
        <span className="totvalue3 value cellval delta">
          {typeof item.value3 === 'object' && item.value3 !== null ? (
            <span className="value3-stack">
              <span className="value3-diff">{item.value3.diff}</span>
              <span className="value3-pct">{item.value3.pct}</span>
            </span>
          ) : item.value3}
        </span>
    </div>
     ))}
  </div>
  );
};


export default Card;
